"use strict";

export const contentIntro = {
  title: 'Fleet work approved and paid',
  description: 'Kia ora New Zealand automotive dealers, major groups, independent service providers and repairers.',
  subText: 'Are you ready to make fleet maintenance easier with AutoGuru?',
  btnLogin: 'Log in',
  btnLearnMore: 'Learn more',
  mobileImgFeaturedPath: 'hero-full-gradient.webp',
  mobileAspectRatioImgFeatured: 1921 / 1222,
  desktopImgFeaturedPath: 'hero-full-gradient.webp',
  desktopAspectRatioImgFeatured: 1921 / 1222,
  altImgFeaturedText: 'dashboard'
};